import { QuestionCircleIcon } from 'library/icons';
import { Tooltip } from 'library/tooltip';
import useDialog from 'modules/shared/hooks/useDialog';
import TutorialLinkModal from '../TutorialLinkModal/TutorialLinkModal';

const TutorialLinkBar = () => {
    const tutorialModalDialog = useDialog();

    return (
        <>
            <Tooltip content={<div className="max-w-[280px] text-center">ProgressCenter Introduction</div>}>
                <div className="flex items-center">
                    <button onClick={tutorialModalDialog.show}>
                        <QuestionCircleIcon width={20} height={20} />
                    </button>
                </div>
            </Tooltip>

            <TutorialLinkModal
                show={tutorialModalDialog.isOpen}
                onClose={tutorialModalDialog.hide}
                src={'https://vimeo.com/1049203102/b0d4dd1858'}
            />
        </>
    );
};

export default TutorialLinkBar;
